import { cn } from '@core/utils';
import { useContext } from 'react';

import type { HTMLTagProps } from '../../../../types';
import { BottomDrawerContext } from '..';

type BottomDrawerHandleProps = HTMLTagProps<'button'>;

export const Handle = ({
  className,
  onClick,
  type = 'button',
  ...restProps
}: BottomDrawerHandleProps) => {
  const context = useContext(BottomDrawerContext);

  if (!context)
    throw new Error(
      'BottomDrawer.Handle은 BottomDrawer 내부에서만 사용할 수 있습니다.',
    );

  return (
    <button
      {...restProps}
      className={cn('h-4 w-44 cursor-pointer bg-Gray-300', className)}
      type={type}
      onClick={(e) => {
        onClick?.(e);
      }}
    />
  );
};
